// src/router/index.js
import { baseRouter as router } from '@r7e/shared';

router.addRoute(    
    {
        path: '/docs',
        name: 'Documentation',
        component: () => import('../views/DocumentationView.vue')
    }
)
// Router
router.addRoute(
    {
        path: '/',
        name: 'Home',
        component: () => import('../views/HomeView.vue'),
        meta: { requiresAuth: false }
    }
)
router.addRoute(    
    {
        path: '/info',
        name: 'ConsumerInfo',
        component: () => import('../views/ConsumerInfo.vue'),
        meta: { requiresAuth: true }
    }
)
router.addRoute(
    {
        path: '/transactions',
        name: 'ConsumerTransactions',
        component: () => import('../views/ConsumerTransactions.vue'),
        meta: { requiresAuth: true }
    }
)
router.addRoute(    
    {
        path: '/reports',
        name: 'ConsumerReportList',
        component: () => import('../views/ConsumerReportList.vue'),
        meta: { requiresAuth: true }
    }
)
router.addRoute(    
    {
        path: '/invoices',
        name: 'Invoices',
        component: () => import('../views/InvoicesList.vue'),
        meta: { requiresAuth: true }
    }
)
router.addRoute(    
    {
        path: '/invoices/:start/:end',
        name: 'InvoiceView',
        component: () => import('../views/InvoiceView.vue'),
        meta: { requiresAuth: true }
    }
)
router.addRoute(    
    {
        path: '/invoices/:start/:end/publishers/',
        name: 'InvoicesPerPublisher',
        component: () => import('../views/InvoicesDataList.vue'),
        meta: { requiresAuth: true }
    }
)
router.addRoute(    
    {
        path: '/invoices/:consumer/:start/:end/publishers/:publisher/',
        name: 'InvoiceForPublisher',
        component: () => import('../views/InvoicePublisherView.vue'),
        meta: { requiresAuth: true }
    }
)
// router.addRoute(    
//     {
//         path: '/settings', 
//         name: 'Settings',
//         component: () => import('../views/ConsumerSettingsView.vue'),
//         meta: { requiresAuth: true }
//     }
// )

export {router};
export default router;